import * as Y from "yjs";
import { DateTime } from "luxon";

const isValidDate = dateString => ( new DateTime( dateString ).isValid );

const DEFAULT_DESERIALIZATION_TYPE = "getXmlFragment";
const DESERIALIZATION_TYPE_MAP = {
	TEAMING_META: "getMap",
	SUBDOC_META: "getMap",
};

function ensureSubDocMeta( ydoc ) {
	let subDocMeta = ydoc.getMap( "SUBDOC_META" );
	if ( !subDocMeta ) {
		subDocMeta = new Y.Map();
		ydoc.getMap( "SUBDOC_META", subDocMeta );
	}
	return subDocMeta;
}

function ensurePendingDeletesSubDocMeta( ydoc ) {
	let pendingDeletes = ydoc.getArray( "PENDING_SUBDOC_DELETES" );
	if ( !pendingDeletes ) {
		pendingDeletes = new Y.Array();
		ydoc.getArray( "PENDING_SUBDOC_DELETES", pendingDeletes );
	}
	return pendingDeletes;
}

const subDocDefaults = {
	subDocId: "",
	title: "",
	date: "",
	virtualMeetingUrl: "",
};

export default class StreamYdoc {
	constructor( { documentName, } ) {
		this.documentName = documentName;
		this.ydoc = new Y.Doc();
		[ ...this.ydoc.share.keys(), ].forEach( k => {
			const typeToGet = DESERIALIZATION_TYPE_MAP[ k ] || DEFAULT_DESERIALIZATION_TYPE;
			this.ydoc[ typeToGet ]( k );
		} );
		ensureSubDocMeta( this.ydoc );
		ensurePendingDeletesSubDocMeta( this.ydoc );
	}
	getSubDocs() {
		const subDocMeta = ensureSubDocMeta( this.ydoc );
		const subDocs = [];
		for ( const [ key, item, ] of subDocMeta.entries() ) { // eslint-disable-line no-unused-vars
			subDocs.push( {
				...subDocDefaults,
				...item,
			} );
		}
		return subDocs;
	}
	addSubDoc( { subDocId, title = "", creator = "", virtualMeetingUrl = "", } ) {
		const utcNoteDate = DateTime.utc();
		this.ydoc.transact( () => {
			const date = utcNoteDate.toFormat( "yyyy-MM-dd TT" );
			this.ydoc.getXmlFragment( subDocId ); // creates the document fragment?
			const subDocMeta = ensureSubDocMeta( this.ydoc );
			subDocMeta.set( subDocId, { subDocId, date, title, creator, virtualMeetingUrl, } );
		} );
		return { subDocId, date: utcNoteDate.toISO(), title, };
	}
	// We need to be seriously defensive towards ANY edits made to the ydoc.
	// An invalid date here could result in a render error when rendering the
	// stream, and a render error in the stream could wreak havoc on the stream
	// doc if tiptap got far enough to stand up the provider, etc.
	changeSubDocDate( { subDocId, date, } ) {
		if ( isValidDate( date ) ) {
			const subDocMeta = this.ydoc.getMap( "SUBDOC_META" );
			const targetSubDoc = subDocMeta.get( subDocId );
			targetSubDoc.date = date;
			subDocMeta.set( subDocId, targetSubDoc );
		}
	}
	changeSubDocTitle( { subDocId, title, } ) {
		const subDocMeta = this.ydoc.getMap( "SUBDOC_META" );
		const targetSubDoc = subDocMeta.get( subDocId );
		targetSubDoc.title = title;
		subDocMeta.set( subDocId, targetSubDoc );
	}
	changeSubDocVirtualMeetingUrl( { subDocId, virtualMeetingUrl, } ) {
		const subDocMeta = this.ydoc.getMap( "SUBDOC_META" );
		const targetSubDoc = subDocMeta.get( subDocId );
		targetSubDoc.virtualMeetingUrl = virtualMeetingUrl;
		subDocMeta.set( subDocId, targetSubDoc );
	}
	removeSubDoc( { subDocId, } ) {
		this.ydoc.transact( () => {
			this.ydoc.getMap( "SUBDOC_META" ).delete( subDocId );
			this.ydoc.getArray( "PENDING_SUBDOC_DELETES" ).push( [ subDocId, ] );
			this.ydoc.share.delete( subDocId );
		} );
	}
	purge() {
		this.ydoc?.off();
		this.ydoc = undefined;
	}
}
